import { TestimonialsSection } from "@/components/blocks/testimonials-with-marquee";

const testimonials = [
  {
    author: {
      name: "Erica Archer",
      handle: "Media Director, Razorfish",
      avatar: "https://consumr.ai/wp-content/uploads/2023/12/Erica.png",
    },
    text: "The use of consumr.ai has transformed our overall media planning and execution process as well as majorly impacted all our success metrics across the consumer funnel. We also used the platform to uncover broad insights about our audience for use in the overall planning process. Understanding where our audience goes in the physical world helped us understand where we could place OOH. We generated contextual keyword lists for programmatic targeting that generated better engagement at lower cost. ",
    // href: "https://twitter.com/emmaai",
  },
  {
    author: {
      name: "Taylor Aramburu",
      handle: "Channel Manager - BBQGuys",
      avatar: "https://consumr.ai/wp-content/uploads/2024/01/image.jpeg",
    },
    text: "ProfitWheel provides our team with valuable tools to optimize our campaigns and help us make more data-driven decisions. With the help of their platform, we've discovered pivotal insights that have increased our ROAS and have made our audience targeting more efficient. The platform is very user friendly and ProfitWheel's team have supported us every step of the way.",
    href: "https://twitter.com/davidtech",
  },
  {
    author: {
      name: "Raphael Rivilla",
      handle: "Chief Media Officer, Marcus Thomas, LLC",
      avatar: "https://consumr.ai/wp-content/uploads/2023/12/rr.png",
    },
    text: "Collaboration with ProfitWheel helped us gain a clear understanding of our current customers' interests without compromising their privacy. These insights guided us in expanding our reach on Meta, attracting even more potential customers. It was a new and effective approach to using our knowledge about existing customers to find new ones. ProfitWheel facilitated all this while ensuring compliance with privacy laws. This success has fueled our excitement to continue using consumr.ai and build a long-term partnership between Halo Collar and ProfitWheel.",
  },
  {
    author: {
      name: "Seth Solomons",
      handle: "Chief Marketing Officer - Halo Collar",
      avatar: "https://consumr.ai/wp-content/uploads/2023/12/Seth.png",
    },
    text: "Marcus Thomas clients have benefited from ProfitWheel’s technologies not just by way of gaining transparency into walled gardens, unpacking 1st party data, scaling in domestic and international markets but also helping in non transactional, mid & upper funnel media activation.	",
  },
];

export function Testimonials() {
  return (
    <TestimonialsSection
      chip="Client Success"
      title="What Our Clients Are Saying"
      description="Hear from marketing leaders who have transformed their creative process"
      testimonials={testimonials}
    />
  );
}
